// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-stepper::ng-deep .mat-horizontal-stepper-header, mat-stepper::ng-deep .mat-vertical-stepper-header {
  pointer-events: none !important;
}
mat-stepper::ng-deep .mat-horizontal-stepper-content, mat-stepper::ng-deep .mat-vertical-stepper-content {
  margin-top: 2rem;
}
mat-stepper::ng-deep button[matStepperPrevious] {
  margin-left: 0.5rem;
}

.page-title {
  text-align: center;
  margin-top: 50px;
}

.stepper {
  max-width: 1024px;
  width: 100%;
  margin: auto;
}

.toast-button-group.toast-button-group-end {
  display: block;
  text-align: center;
  margin: 20px;
}

.toast-button-inner {
  font-family: IRANSans;
  background-color: blue;
  padding: 10px;
  color: white;
  border-radius: 10px;
}

.button-style {
  --button-color: "primary";
}`, "",{"version":3,"sources":["webpack://./src/app/features/quote-request/quote-request.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/quote-request/quote-request.component.scss"],"names":[],"mappings":"AACI;EACE,+BAAA;ACAN;ADGI;EACE,gBAAA;ACDN;ADGI;EACE,mBAAA;ACDN;;ADIE;EACE,kBAAA;EACA,gBAAA;ACDJ;;ADGE;EACE,iBAAA;EACA,WAAA;EACA,YAAA;ACAJ;;ADEE;EACE,cAAA;EACA,kBAAA;EACA,YAAA;ACCJ;;ADEE;EACE,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;ACCJ;;ADCE;EACE,yBAAA;ACEJ","sourcesContent":["mat-stepper::ng-deep {\r\n    .mat-horizontal-stepper-header, .mat-vertical-stepper-header {\r\n      pointer-events: none !important;\r\n    }\r\n  \r\n    .mat-horizontal-stepper-content, .mat-vertical-stepper-content {\r\n      margin-top: 2rem;\r\n    }\r\n    button[matStepperPrevious]{\r\n      margin-left: .5rem;\r\n    }\r\n  }\r\n  .page-title {\r\n    text-align: center;\r\n    margin-top: 50px;\r\n  }\r\n  .stepper {\r\n    max-width: 1024px;\r\n    width: 100%;\r\n    margin: auto;\r\n  }\r\n  .toast-button-group.toast-button-group-end{\r\n    display: block;\r\n    text-align: center;\r\n    margin: 20px;\r\n  }\r\n  \r\n  .toast-button-inner{\r\n    font-family: IRANSans;\r\n    background-color: blue;\r\n    padding: 10px;\r\n    color: white;\r\n    border-radius: 10px;\r\n  }\r\n  .button-style{\r\n    --button-color: 'primary';\r\n  }\r\n  ","mat-stepper::ng-deep .mat-horizontal-stepper-header, mat-stepper::ng-deep .mat-vertical-stepper-header {\n  pointer-events: none !important;\n}\nmat-stepper::ng-deep .mat-horizontal-stepper-content, mat-stepper::ng-deep .mat-vertical-stepper-content {\n  margin-top: 2rem;\n}\nmat-stepper::ng-deep button[matStepperPrevious] {\n  margin-left: 0.5rem;\n}\n\n.page-title {\n  text-align: center;\n  margin-top: 50px;\n}\n\n.stepper {\n  max-width: 1024px;\n  width: 100%;\n  margin: auto;\n}\n\n.toast-button-group.toast-button-group-end {\n  display: block;\n  text-align: center;\n  margin: 20px;\n}\n\n.toast-button-inner {\n  font-family: IRANSans;\n  background-color: blue;\n  padding: 10px;\n  color: white;\n  border-radius: 10px;\n}\n\n.button-style {\n  --button-color: \"primary\";\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
